$(function() {
    $('body').on('click', '.section__content ul li a', function (e) {
        e.preventDefault();

        var href = $(this).attr('href');

        if (!! /#\w+/.test(href)) {
            href = href.replace('#', '');

            var place =  '.' + $(this).closest('.envs__block').data('switch-block');

            $('html, body').animate({
                scrollTop: ($(`${place} [name="${href}"]`).offset().top - 100)
            }, 700);

            return;
        }

        switch ($(this).attr('target')) {
            case '_blank':
                window.open(href, '_blank');
                break;
            case '_self':
                window.open(href, '_self');
                break;
            case '_top':
                window.open(href, '_top');
                break;
            case '_parent':
                window.open(href, '_parent');
                break;
            default:
                window.open(href, '_self');
        }
    });
});
